import { render, staticRenderFns } from "./LinkButtons.vue?vue&type=template&id=221c316b"
import script from "./LinkButtons.vue?vue&type=script&lang=js"
export * from "./LinkButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports